import { useEffect, useState } from "react";
import { api } from "../lib/api";

function Empty({ label, cols }) {
  return <tr><td colSpan={cols} className="p-8 text-center text-muted_ink">No {label} yet</td></tr>;
}

export function AdminCounselling() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/counselling").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="admin-counselling-page">
      <p className="overline text-terracotta mb-2">Submissions</p>
      <h1 className="font-heading font-black text-4xl tracking-tighter text-olive mb-8">Counselling Enquiries</h1>
      <div className="bg-white border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-cream border-b border-border">
            <tr className="text-left">
              <th className="p-4 font-semibold">Name</th>
              <th className="p-4 font-semibold">Email</th>
              <th className="p-4 font-semibold">Phone</th>
              <th className="p-4 font-semibold">Type</th>
              <th className="p-4 font-semibold">Preferred</th>
              <th className="p-4 font-semibold">Message</th>
              <th className="p-4 font-semibold">Submitted</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? <Empty label="enquiries" cols={7} /> : items.map((m) => (
              <tr key={m.id} className="border-b border-border last:border-0">
                <td className="p-4 font-medium text-ink">{m.full_name}</td>
                <td className="p-4 text-muted_ink">{m.email}</td>
                <td className="p-4 text-muted_ink">{m.phone}</td>
                <td className="p-4"><span className="bg-terracotta text-white px-2.5 py-1 text-xs font-semibold">{m.counselling_type}</span></td>
                <td className="p-4 text-muted_ink">{m.preferred_contact}</td>
                <td className="p-4 text-muted_ink max-w-xs truncate" title={m.message}>{m.message || "—"}</td>
                <td className="p-4 text-muted_ink">{new Date(m.created_at).toLocaleDateString("en-ZA")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function AdminHomecell() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/homecell").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="admin-homecell-page">
      <p className="overline text-terracotta mb-2">Submissions</p>
      <h1 className="font-heading font-black text-4xl tracking-tighter text-olive mb-8">Homecell Signups</h1>
      <div className="bg-white border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-cream border-b border-border">
            <tr className="text-left">
              <th className="p-4 font-semibold">Name</th>
              <th className="p-4 font-semibold">Email</th>
              <th className="p-4 font-semibold">Phone</th>
              <th className="p-4 font-semibold">Suburb</th>
              <th className="p-4 font-semibold">City</th>
              <th className="p-4 font-semibold">Info</th>
              <th className="p-4 font-semibold">Submitted</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? <Empty label="signups" cols={7} /> : items.map((m) => (
              <tr key={m.id} className="border-b border-border last:border-0">
                <td className="p-4 font-medium text-ink">{m.full_name}</td>
                <td className="p-4 text-muted_ink">{m.email}</td>
                <td className="p-4 text-muted_ink">{m.phone}</td>
                <td className="p-4 text-ink font-semibold">{m.suburb}</td>
                <td className="p-4 text-muted_ink">{m.city || "—"}</td>
                <td className="p-4 text-muted_ink max-w-xs truncate" title={m.additional_info}>{m.additional_info || "—"}</td>
                <td className="p-4 text-muted_ink">{new Date(m.created_at).toLocaleDateString("en-ZA")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
